var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "folderNode" }, [
    _c(
      "div",
      {
        staticClass: "nodeHead",
        on: {
          contextmenu: function($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.onContextmenu($event)
          }
        }
      },
      [
        _vm.folder.Children && _vm.folder.Children.length
          ? _c("vsvg", {
              class: {
                nodeIcon: true,
                visible: true,
                collapsed: !_vm.expanded
              },
              attrs: { sprite: "expand_more", tabindex: "0" },
              on: {
                click: _vm.toggleExpansion,
                keypress: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.toggleExpansion($event)
                }
              }
            })
          : _c("div", { staticClass: "nodeIcon" }),
        _vm._v(" "),
        _c(
          "FolderLink",
          {
            ref: "myNode",
            class: {
              link: true,
              selected: _vm.selected,
              moving: _vm.moving,
              dragTarget: _vm.isDragTarget
            },
            attrs: {
              to: _vm.openFolderRoute,
              clickFn: _vm.folderLinkClick,
              draggable: _vm.movingItem ? "false" : "true",
              title: _vm.linkTitle
            },
            nativeOn: {
              dragstart: function($event) {
                return _vm.dragStart($event)
              },
              dragover: function($event) {
                return _vm.dragOver($event)
              },
              dragenter: function($event) {
                return _vm.dragEnter($event)
              },
              dragleave: function($event) {
                return _vm.dragLeave($event)
              },
              drop: function($event) {
                return _vm.onDrop($event)
              }
            }
          },
          [
            _vm.isAllFolders
              ? _c("span", { staticClass: "folderIcon" }, [_vm._v("🗄️")])
              : _vm.selected
              ? _c("span", { staticClass: "folderIcon" }, [_vm._v("📂")])
              : _c("span", { staticClass: "folderIcon" }, [_vm._v("📁")]),
            _vm._v(" "),
            _c("span", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.folder.Name))
            ]),
            _vm._v(" "),
            _vm.folder.Unread
              ? _c("span", { staticClass: "unread" }, [
                  _vm._v("(" + _vm._s(_vm.folder.Unread) + ")")
                ])
              : _vm._e()
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.expanded,
            expression: "expanded"
          }
        ],
        staticClass: "children"
      },
      _vm._l(_vm.folder.Children, function(child) {
        return _c("FolderNode", {
          key: "folder" + child.FolderId,
          ref: "childNodes",
          refInFor: true,
          attrs: {
            projectName: _vm.projectName,
            folder: child,
            selectedFolderId: _vm.selectedFolderId,
            isDialog: _vm.isDialog,
            dialogAllowsAllFolders: _vm.dialogAllowsAllFolders
          },
          on: {
            select: _vm.onSelect,
            menu: _vm.onMenu,
            moveInto: _vm.onMoveInto
          }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }